import React, { useEffect, useState } from 'react';

import { useGetAccountInfo, useGetIsLoggedIn } from '@multiversx/sdk-dapp/hooks';
import { BytesValue, U32Value } from '@multiversx/sdk-core/out';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import axios from 'axios';
import BigNumber from 'bignumber.js/bignumber';
import clsx from 'clsx';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CustomButton } from 'components';
import { CustomInput } from 'components/CustomInput';
import { contracts, ElrondApiUrl } from 'config/config';
import { BigZero, coinNames } from 'helpers/constant';
import { convertWeiToEsdt, getSymbol, shortenEsdt } from 'helpers/utils';
import { useInteraction } from 'Interaction';
import { routeNames } from 'routes';

import styles from './styles.module.scss';
import { Box, Step, StepIconProps, StepLabel, Stepper, styled } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 8,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',

            background: '#FFBC0A'
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
            background: '#FFBC0A'
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 2,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#D3D3D3',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
    // border: '1px solid gray',
    zIndex: 1,
    color: '#000',
    width: 20,
    height: 20,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    ...(ownerState.active && {

        // backgroundImage:
        //     'linear-gradient( 136deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
        background: '#FFBC0A',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        color: '#000',
    }),
    ...(ownerState.completed && {
        // backgroundImage:
        //     'linear-gradient( 136deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
        background: '#FFBC0A',
        color: '#000',
    }),
}));

function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
        1: <div>1</div>,
        2: <div>2</div>,
        3: <div>3</div>,
        4: <div>4</div>,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

export const CreatePool = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [firstToken, setFirstToken] = useState('');
    const [secondToken, setSecondToken] = useState('WEGLD-d7c6bb');
    const [lpTokenName, setLpTokenName] = useState('');
    const [lpToken, setLpToken] = useState('');
    
    const [pairIdForLpIssue, setPairIdForLpIssue] = useState(0);
    const [pairIdForRole, setPairIdForRole] = useState(0);
    const [pairIdForAddLp, setPairIdForAddLp] = useState(0);
    const [currentPair, setCurrentPair] = useState<any>(undefined);

    const [firstTokenAmount, setFirstTokenAmount] = useState(BigZero);
    const [secondTokenAmount, setSecondTokenAmount] = useState(BigZero);
    const [egldBalance, setEgldBalance] = useState(BigZero);

    const [price, setPrice] = useState(BigZero);

    const [egldPair, setEgldPair] = useState(false);

    const isLoggedIn = useGetIsLoggedIn();
    const { account: {address: userAddress, balance: userBalance} } = useGetAccountInfo();

    const navigate = useNavigate();
    const { userPairInfos, callMethod } = useInteraction();

    useEffect(() => {
        setEgldBalance(convertWeiToEsdt(userBalance, 18));
    }, [userBalance]);

    useEffect(() => {
        if(
            !currentPair ||
            BigZero.gte(firstTokenAmount) ||
            BigZero.gte(secondTokenAmount)
        ) {
            setPrice(BigZero);
            return;
        }

        setPrice(
            secondTokenAmount.dividedBy(firstTokenAmount)
          );
    }, [firstTokenAmount, secondTokenAmount, currentPair]);

    useEffect(() => {
        if(!userAddress || !currentPair) return;

        (async () => {
            if(pairIdForAddLp > 0) {

                if(currentPair.second_token_id.toString() === coinNames[1]) {
                    setEgldPair(true);
                } else {
                    setEgldPair(false);
                }
            }
        })();
    }, [userAddress, currentPair]);

    useEffect(() => {
        setActiveStep(0);
        for(const pair of userPairInfos) {
            if(pair.lp_token_id === '') {
                setPairIdForLpIssue(pair.pair_id.toNumber());
                setCurrentPair(pair);

                setActiveStep(1);

                break;
            } else {
                setPairIdForLpIssue(0);
            }

            if(!pair.lp_token_roles_are_set) {
                setPairIdForRole(pair.pair_id.toNumber());
                setCurrentPair(pair);

                setActiveStep(2);

                break;
            } else {
                setPairIdForRole(0);
            }

            if(BigZero.isEqualTo(pair.first_token_reserve)) {
                setPairIdForAddLp(pair.pair_id.toNumber());
                setCurrentPair(pair);

                setActiveStep(3);

                break;
            } else {
                setPairIdForAddLp(0);
            }
        }
    }, [userPairInfos]);

    useEffect(() => {
        if(!isLoggedIn) {
            navigate(routeNames.unlock);
        }
    }, [isLoggedIn]);

    const createPair = async () => {
        if(firstToken.length === 0) return;

        try {
            const { data } = 
                await axios.get(`${ElrondApiUrl}/tokens/${firstToken}`);

            if(data.owner !== userAddress) {
                throw 'User is not the creator of First token';
            }

            const decimals = data.decimals >= 0 ?  data.decimals : 18;
    
            await callMethod({
                contract: contracts.Dex,
                method: 'createPair',
                args: [
                    BytesValue.fromUTF8(firstToken),
                    BytesValue.fromUTF8(secondToken),
                    new U32Value(decimals),
                    new U32Value(secondToken === coinNames[1] ? 18 : 6),
                ],
            });

            setFirstTokenAmount(BigZero);
            setSecondTokenAmount(BigZero);
        } catch(error: any) {
            if(error?.response) {
                const { message } = error.response.data;

                toast.error(message);
            } else if(typeof(error) === 'string') {
                toast.error(error);
            }
            console.log(error);
        }
    };

    const createIssueLp = async () => {
        if(
            lpTokenName.length < 3 || lpTokenName.length > 20 ||
            lpToken.length < 3 || lpToken.length > 10
        ) return;

        try {
            await callMethod({
                contract: contracts.Dex,
                method: 'issueLpToken',
                args: [
                    new U32Value(pairIdForLpIssue),
                    BytesValue.fromUTF8(lpTokenName),
                    BytesValue.fromUTF8(lpToken),
                ],
                egld: '0.05',
            });

        } catch(error: any) {
            console.log(error);
        }
    };

    const setRole = async () => {
        if(pairIdForRole === 0) return;

        try {
            await callMethod({
                contract: contracts.Dex,
                method: 'setLpTokenLocalRoles',
                args: [new U32Value(pairIdForRole)],
            });

            setLpToken('');
            setLpTokenName('');
        } catch(error: any) {
            console.log(error);
        }
    };

    const addInitialLp = async () => {
        if(
            BigZero.isEqualTo(firstTokenAmount) || firstTokenAmount.gt(currentPair.first_token_balance) ||
            BigZero.isEqualTo(secondTokenAmount) || secondTokenAmount.gt(egldPair ? egldBalance : currentPair.second_token_balance)
        ) return;

        try {
            await callMethod({
                contract: contracts.Dex,
                method: 'addInitialLiquidity',
                args: [],
                fts: [
                    {
                        token: currentPair.first_token_id,
                        amount: firstTokenAmount,
                        decimals: currentPair.first_token_decimal.toNumber()
                    },
                    {
                        token: currentPair.second_token_id,
                        amount: secondTokenAmount,
                        decimals: currentPair.second_token_decimal.toNumber()
                    }
                ],
                wrap: egldPair ? secondTokenAmount : BigZero
            });

            setFirstToken('');
        } catch(error: any) {
            console.log(error);
        }
    };

    const getBody = () => {
        if(pairIdForLpIssue === 0 && pairIdForAddLp === 0 && pairIdForRole === 0) {
            return (
                <div className={styles.cardBody}>
                    <h3 className='text-white text-left mb-4'>CREATE SWAP POOL</h3>
                    <h6 className='text-white text-left'>First Token</h6>
                    <input
                        value={firstToken}
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        type='text'
                        placeholder='Token Identifier'
                        onChange={(e) => {
                            const parts = e.target.value.split('-');
                            let token = parts[0].toUpperCase();
                            if(parts.length > 1) {
                                token =  token + '-' + parts[1];
                            }

                            setFirstToken(token);
                        }}
                    />
                    <span className={styles.warning}>Only Token Creator could list his token</span>
                    <h6 className='text-white text-left mt-4'>Second Token</h6>
                    <Form.Select
                        className={styles.second}
                        aria-label='Second Token Selector'
                        onChange={(e) => setSecondToken(e.target.value)}
                    >
                        <option value={coinNames[1]}>
                            EGLD
                        </option>
                        <option value={coinNames[2]}>
                            USDC
                        </option>
                    </Form.Select>
                    <CustomButton
                        className={styles.applyButton}
                        onClick={() => createPair()}
                    >
                        Create Pair
                    </CustomButton>
                </div>
            );
        } else if (pairIdForLpIssue !== 0) {
            return (
                <div className={styles.cardBody}>
                    <h3 className='text-white text-left mb-4'>ISSUE LP TOKEN</h3>
                    <h6 className='text-white text-left'>LP Token Name</h6>
                    <input
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        type='text'
                        placeholder='Token Name'
                        value={lpTokenName}
                        onChange={(e) => {
                            const value = e.target.value;
                            const token = value.replace(/[^a-z0-9]/gi,'');
                            if(token.length < 21) {
                                setLpTokenName(token);
                            }
                        }}
                    />
                    <span className={styles.warning}>3~20 alphanumeric characters </span>
                    <h6 className='text-white text-left mt-4'>LP Token Ticker</h6>
                    <input
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        type='text'
                        placeholder='Token Identifier'
                        value={lpToken}
                        onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            const token = value.replace(/[^a-z0-9]/gi,'');
                            if(token.length < 11) {
                                setLpToken(token);
                            }
                        }}
                    />
                    <span className={styles.warning}>3~10 characters</span>
                    <CustomButton
                        className={styles.applyButton}
                        onClick={() => createIssueLp()}
                    >
                        Issue
                    </CustomButton>
                </div>
            );

        } else if(pairIdForRole !== 0) {
            return (
                <div className={styles.cardBody}>
                    <h3 className='text-white text-left mb-4'>SET ROLE TO MINT/BURN LP TOKEN</h3>
                    <span className={styles.warning} style={{ fontSize: 20 }}>{currentPair.lp_token_id}</span>
                    <CustomButton
                        className={styles.applyButton}
                        onClick={() => setRole()}
                    >
                        Set
                    </CustomButton>
                </div>
            );
        } else if (pairIdForAddLp !== 0) {
            return (
                <div className={styles.cardBody}>
                    <h3 className='text-white text-left mb-4'>Add Initial Liquidity</h3>
                    <h6 className='text-white text-left'>First Token Amount</h6>
                    <span className='text-info'>{currentPair.first_token_id}</span>
                    <span className='text-white'>Balance: {shortenEsdt(currentPair.first_token_balance)}</span>
                    <CustomInput
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        placeholder='Amount'
                        value={firstTokenAmount}
                        maxValue={currentPair.first_token_balance}
                        setAmount={(newAmount: BigNumber) => {
                            if(newAmount.lte(currentPair.first_token_balance)) {
                                setFirstTokenAmount(newAmount);
                            }
                        }}
                    />
                    <h6 className='text-white text-left mt-4'>Second Token Amount</h6>
                    <span className='text-info'>{egldPair ? 'EGLD' : currentPair.second_token_id}</span>
                    <span className='text-white'>Balance: {shortenEsdt(egldPair ? egldBalance : currentPair.second_token_balance)}</span>
                    <CustomInput
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        placeholder='Amount'
                        value={secondTokenAmount}
                        maxValue={egldPair ? egldBalance : currentPair.second_token_balance}
                        setAmount={(newAmount: BigNumber) => {
                            if(newAmount.lte(egldPair ? egldBalance : currentPair.second_token_balance)) {
                                setSecondTokenAmount(newAmount);
                            }
                        }}
                    />
                    {
                        BigZero.lt(price) ? (
                            <>
                                <span className='text-info mt-3'>1 {getSymbol(currentPair?.first_token_id || '')} ≃ {shortenEsdt(price, 6)} {getSymbol(currentPair?.second_token_id || '')}</span>
                                <span className='text-info'>1 {getSymbol(currentPair?.second_token_id || '')} ≃ {shortenEsdt(new BigNumber(1).dividedBy(price), 6)} {getSymbol(currentPair?.first_token_id || '')}</span>
                            </>
                        ) : (
                            <></>
                        )
                    }
                    <div className='text-white mt-4'>
                        <div className={'d-flex justify-content-start w-100 px-2 mt-2'}>
                            <span>You will be asked to sign { egldPair ? 2 : 1 } transactions</span>
                        </div>
                        {
                            egldPair ? (
                                <>
                                    <div className={'d-flex justify-content-between w-100 px-2 mt-2'}>
                                        <span>1.</span>
                                        &nbsp;
                                        <span>Wrap EGLD</span>
                                    </div>
                                    <div className={'d-flex justify-content-start w-100 px-2 mt-2'}>
                                        <span>2.</span>
                                        &nbsp;
                                        <span>Add Initial Liquidity</span>
                                    </div>
                                </>
                            ) : (
                                <div className={'d-flex justify-content-start w-100 px-2 mt-2'}>
                                    <span>1.</span>
                                    &nbsp;
                                    <span>Add Initial Liquidity</span>
                                </div>
                            )
                        }
                    </div>
                    <CustomButton
                        className={styles.applyButton}
                        onClick={() => addInitialLp()}
                    >
                        Add
                    </CustomButton>
                </div>
            );
        }
    };

    const steps = ['Create Swap Pool', 'Issue LP Token', 'Set Role', 'Add Initial Liquidity'];
    
    return(
        <div className='d-flex flex-column flex-fill align-items-center justify-content-start'>
            <div className={styles.body}>
                <div
                    onClick={() => navigate('/pool')}
                    className={clsx(styles.back, 'w-100 d-flex justify-content-start text-white')}
                >
                    <NavigateBeforeIcon />
                    Back to Pools
                </div>
                <Box sx={{ width: '100%', marginTop: '40px' }}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                >
                                    <span style={{ color: '#D3D3D3', fontSize: '13px', fontFamily: 'poppins' }}>{label}</span>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
            </div>
            <div className={clsx(styles.card, 'card shadow-sm mx-5')}>
                {getBody()}
            </div>
        </div>
    );
};
